module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.29407",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9691",
      "ably-hubspot-js": "static-2.4741",
      "atom": "static-1.5097",
      "conversations-error-reporting": "static-1.8910",
      "conversations-internal-pub-sub": "static-1.16003",
      "conversations-internal-schema": "static-1.12944",
      "conversations-message-history": "static-1.12766",
      "conversations-test-sdk": "static-1.10528",
      "conversations-visitor-experience-components": "static-1.22770",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5615",
      "hs-test-utils": "static-1.8038",
      "hubspot-dlb": "static-2.1854",
      "HubStyleTokens": "static-2.11496",
      "I18n": "static-7.1631",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.3045",
      "jasmine-runner": "static-1.6488",
      "quartz": "static-1.7062",
      "react-dlb": "static-1.79",
      "react-select-plus": "static-1.105",
      "react-transition-group": "static-2.65",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4500",
      "StyleGuideUI": "static-3.487",
      "transmute": "static-2.85",
      "urlinator": "static-1.4561",
      "usage-tracker": "static-1.7372",
      "usage-tracker-core": "static-1.7222",
      "usage-tracker-public": "static-1.7183",
      "viral-links-lib": "static-1.7090",
      "visitor-ui-component-library": "static-1.6161",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4838",
      "conversations-prop-types": "static-1.7476",
      "conversations-visitor-message-history": "static-1.21507",
      "cssUtils": "static-1.798",
      "enviro": "static-4.455",
      "flux-actions": "static-1.341",
      "foundations-components": "static-1.7983",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6246",
      "hubspot-url-utils": "static-1.4132",
      "immutable": "static-2.79",
      "metrics-js": "static-1.9637",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "react": "static-7.186",
      "react-aria": "static-1.66",
      "react-dom": "static-7.85",
      "react-redux": "static-7.71",
      "react-rhumb": "static-1.16695",
      "react-utils": "static-2.5362",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8167",
      "signup-constants": "static-1.18888",
      "styled-components": "static-2.89",
      "usage-tracker-multi": "static-1.5786",
      "visitor-ui-component-library-icons": "static-1.5972",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3417",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.86",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.82",
      "quartz-config": "static-1.840",
      "quartz-core": "static-1.6281",
      "foundations-assets": "static-1.4892",
      "foundations-theming": "static-1.4444",
      "UIComponents": "static-3.8442",
      "conversations-async-data": "static-2.7687",
      "customer-data-email": "static-1.18074",
      "cv-backend-services": "static-1.1553",
      "immutable-less": "static-1.4677",
      "conversations-skeleton-state": "static-1.7272",
      "crm-events-viz-core": "static-1.33266",
      "customer-data-objects": "static-1.7697",
      "icons": "static-2.650",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4676",
      "ui-images": "static-2.1160",
      "HeadJS": "static-2.764",
      "framer-motion": "static-1.72",
      "hs-test-utils-bend-plugin": "static-1.3149",
      "msw": "static-1.39",
      "testing-library": "static-1.152",
      "i18n-data": "static-1.221",
      "moment-timezone": "static-5.83",
      "jasmine": "static-4.4351",
      "signup-ui-url-generator": "static-2.8077",
      "HubStyle": "static-2.11803",
      "quartz-i18n": "static-1.737",
      "sassPrefix": "static-1.156",
      "bend-plugin-foundations-components": "static-1.4252",
      "floating-ui": "static-1.56",
      "foundations-theming-specialty": "static-1.2160",
      "hs-story-utils": "static-1.9448",
      "react-create-root-preference": "static-1.29",
      "react-virtualized": "static-2.99",
      "tanstack-table": "static-1.55",
      "trellis-assets": "static-1.2023",
      "ui-fonts": "static-1.758",
      "hs-locale-management": "static-1.98",
      "csstype": "static-1.50",
      "quartz-head": "static-1.727",
      "quick-fetch": "static-1.3934",
      "web-vitals": "static-1.6",
      "quartz-routing": "static-1.492",
      "usage-tracker-anonymous": "static-1.5789",
      "bender-build-tools": "static-1.3215",
      "dispatcher": "static-1.137",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.838",
      "hubspotter-http": "static-1.4669",
      "mobile-manifest-mixins": "static-1.538",
      "module-federation": "static-1.23",
      "quartz-auth": "static-1.737",
      "quartz-test": "static-1.737",
      "quartz-tracking": "static-1.441",
      "usage-tracker-container": "static-1.7362",
      "bend-plugin-foundations-theming": "static-1.2927",
      "foundations-theming-base": "static-1.3429",
      "stylex": "static-1.33",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4676",
      "customer-data-ui-utilities": "static-1.9850",
      "FileManagerCore": "static-1.39188",
      "FileManagerLib": "static-1.39329",
      "hubspot-apollo-client": "static-1.4903",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.525",
      "timezone-utils": "static-2.5269",
      "ui-gdpr-components": "static-1.10374",
      "ts-schema": "static-1.4098",
      "ai-components-ui-library": "static-1.9035",
      "avatar-components": "static-1.2522",
      "content-assistance-lib": "static-1.7788",
      "crm-component-utils": "static-1.39144",
      "crm-display-components": "static-1.24894",
      "crm-fe-perf": "static-1.22928",
      "crm-links": "static-1.6319",
      "crm-message-bus": "static-1.43040",
      "crm-search-service-types": "static-1.1178",
      "crm-source-interpretation-lib": "static-1.5367",
      "customer-data-communicator": "static-1.45614",
      "customer-data-filters-ui": "static-1.39889",
      "customer-data-objects-ui-components": "static-1.13053",
      "customer-data-properties": "static-1.51649",
      "customer-data-rte": "static-1.33062",
      "draft-plugins": "static-2.21716",
      "file-manager-components": "static-1.23689",
      "framework-data-schema-resolvers": "static-1.6909",
      "frontend-preferences-client": "static-1.7951",
      "hubspot-prosemirror": "static-1.18299",
      "object-comments-thread-lib": "static-1.10727",
      "prosemirror-user-and-team-at-mentions": "static-1.648",
      "reference-resolvers-lite": "static-1.8119",
      "ui-addon-upgrades": "static-9.18032",
      "universal-associations-select": "static-1.11062",
      "universal-record-utils-lib": "static-1.974",
      "wootric-nps": "static-1.6998",
      "inbound-db-properties-service-client": "static-1.3864",
      "property-translator": "static-1.5423",
      "bend-plugin-chirp-manifest": "static-1.86",
      "chirp-fetch": "static-1.1912",
      "hub-http-shared-msw-handlers": "static-1.10023",
      "hubspotter-http-shared-msw-handlers": "static-1.10021",
      "usage-tracker-session-replay": "static-1.5058",
      "react-dnd-compat": "static-1.4639",
      "audio-components": "static-1.5951",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29339",
      "FileManagerImages": "static-1.36840",
      "foundations-components-legacy": "static-1.1008",
      "immerable": "static-1.4178",
      "ui-universal-auth": "static-1.9007",
      "video-components": "static-1.13357",
      "video-data-lib": "static-1.35012",
      "video-embed": "static-1.35846",
      "hubspot-apollo-cache": "static-1.362",
      "chatspot-core": "static-1.21412",
      "ContentUtils": "static-1.68438",
      "copilot-toolkit": "static-1.11197",
      "superstore": "static-1.4785",
      "ui-addon-video-player": "static-1.8727",
      "ui-coaching-tips": "static-1.28630",
      "card-properties-lib": "static-1.44261",
      "commerce-subscription-lib": "static-1.37192",
      "crm-actions": "static-1.6351",
      "crm-cards-sdk": "static-1.43662",
      "customer-data-properties-shared-msw-handlers": "static-1.9350",
      "customer-data-property-utils": "static-1.8115",
      "customer-data-tracking": "static-1.6914",
      "hs-resources": "static-1.178",
      "inbound-db-meta-service-client": "static-1.3604",
      "pulse": "static-1.601",
      "framework-data-table": "static-2.11969",
      "location-customization-utils-lib": "static-1.9336",
      "restore-request-side-panel-lib": "static-1.947",
      "calling-error-reporting": "static-1.31333",
      "calling-internal-common": "static-1.31326",
      "calling-usage-tracker": "static-1.6565",
      "crm_data": "static-4.92040",
      "customer-data-content": "static-1.27331",
      "draft-content-plugins": "static-1.28335",
      "draft-convert": "static-2.73",
      "draft-extend": "static-3.75",
      "draft-js": "static-5.78",
      "draft-signature-plugin": "static-1.24135",
      "EmailSignatureEditor": "static-1.24425",
      "hubspot-prosemirror-plugins": "static-1.18291",
      "integration-settings-components": "static-1.15540",
      "integrations-lib": "static-1.16235",
      "integrations-tracking-lib": "static-1.5626",
      "native-integrations-shared-strings": "static-1.7806",
      "nav-meta": "static-1.29747",
      "onboarding-scopes": "static-1.6485",
      "outreach-assistant-email-generation": "static-1.6267",
      "prosemirror-copilot": "static-1.11683",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.38223",
      "react-colorpicker": "static-2.10232",
      "reference-resolvers": "static-1.8195",
      "rich-text-lib": "static-1.19874",
      "sales-email-signature-service-client": "static-1.3868",
      "sequences-lib": "static-1.8083",
      "ui-addon-i18n": "static-1.11173",
      "ui-addon-iframeable": "static-1.9084",
      "ui-business-units-lib": "static-1.9079",
      "ui-shepherd-react": "static-3.10194",
      "user-context": "static-1.5129",
      "whatsapp-sending-lib": "static-1.5775",
      "events-data-lib": "static-1.248",
      "customer-data-filters-ui-msw-helpers": "static-1.22324",
      "customer-data-reference-ui-components": "static-1.13189",
      "FormUrlGenerator": "static-2.4743",
      "framework-builder-read-service-client": "static-1.4023",
      "framework-data-schema-quick-fetch": "static-1.6814",
      "multi-account-reference-resolvers": "static-1.1004",
      "onboarding-tours": "static-1.16658",
      "reporting-datasets-permissions-lib": "static-1.13754",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21589",
      "calling-global-api": "static-1.64597",
      "calling-lifecycle-internal": "static-1.65979",
      "calling-lifecycle-messages": "static-1.58273",
      "commerce-products-lib": "static-1.9657",
      "conditional-properties-service-client": "static-1.3815",
      "external-options-client-types": "static-1.4177",
      "google-libphonenumber": "static-1.38",
      "inbounddb-objects-service-types": "static-1.4241",
      "meetings-icalendar-utils-lib": "static-1.656",
      "multi-currency-client-types": "static-1.3709",
      "object-builder-ui-client": "static-1.48826",
      "pipeline-validation-client-types": "static-1.3983",
      "property-value-citations": "static-1.2263",
      "smart-property-lib": "static-1.7210",
      "tiered-pricing": "static-1.1271",
      "zustand": "static-1.74",
      "ui-addon-form-validation": "static-1.11014",
      "video-components-external": "static-1.11354",
      "batch-promise": "static-1.1566",
      "crm-pipelines-api-client-types": "static-1.4157",
      "fdsr-migration-layer": "static-1.28",
      "persist-promise": "static-1.3723",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25450",
      "knowledge-content-types": "static-1.8496",
      "payment-link-components": "static-1.23610",
      "ui-addon-emoji-picker": "static-1.9912",
      "call-summary": "static-1.39287",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10169",
      "laboratory-lib": "static-3.7180",
      "merchandise-lib": "static-1.264",
      "purchase-motions-components": "static-1.5963",
      "crm-object-search-query-utilities": "static-1.9627",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.803",
      "content-icons-ui": "static-1.2233",
      "social-insights-client-types": "static-1.22183",
      "outpost": "static-1.4203",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4836",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5567",
      "magpie-types": "static-1.5027",
      "simple-logging-lib": "static-1.3075",
      "growth-onboarding-feedback-components": "static-1.6604",
      "customer-data-sidebar": "static-2.46087",
      "enrichment-properties-lib": "static-1.16328",
      "ui-addon-draggable-compat": "static-2.4281",
      "commerce-billing-lib": "static-1.19156",
      "commerce-shared-components-lib": "static-1.18607",
      "commerce-tools-ui-lib": "static-1.10443",
      "bend-plugin-pulse": "static-1.104",
      "directed-graph": "static-1.959",
      "event-emitter": "static-1.972",
      "fast-json-patch": "static-1.63",
      "customer-data-associations": "static-1.7350",
      "reporting-data": "static-1.67661",
      "tanstack-virtual": "static-1.30",
      "ui-addon-draggable": "static-3.4787",
      "crm-record-cards-service-types": "static-1.3615",
      "self-service-api": "static-1.10271",
      "crm_universal": "static-1.22048",
      "SalesContentIndexUI": "static-3.9286",
      "content-embed-lib": "static-1.7363",
      "data-model-builder-lib": "static-1.12424",
      "remote-ui": "static-1.65",
      "ui-components-test-utils": "static-1.5633",
      "ui-extensions-remote-renderer": "static-1.17082",
      "universal-page-editor-lib": "static-1.3037",
      "integrations-error-boundary-lib": "static-1.13650",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10390",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.521",
      "messaging-types-lib": "static-1.46084",
      "ai-addon-copilot-preview": "static-1.8247",
      "copilot-plugins": "static-1.11170",
      "data-token-picker": "static-1.16448",
      "sequences-client-types-lib": "static-1.7940",
      "foundations-components-test-utils": "static-1.5466",
      "navigation-messaging": "static-1.7437",
      "getting-started-shared-tasks": "static-1.18520",
      "getting-started-shared-tasks-store": "static-1.17638",
      "onboarding-tours-utils": "static-1.724",
      "messaging-usage-based-billing-components-lib": "static-1.1209",
      "whatsapp-management-lib": "static-1.8934",
      "growth-data-modal": "static-1.5465",
      "growth-onboarding-confetti": "static-1.3091",
      "growth-onboarding-next-action-utils": "static-1.1990",
      "navigation-components": "static-1.18110",
      "onboarding-tours-client": "static-1.4872",
      "ui-shepherd-tracker": "static-1.7575",
      "shared-worker-versioning": "static-1.11061",
      "voice-sms-access-library": "static-1.1081",
      "commerce-permissions": "static-1.794",
      "products-iframe-lib": "static-1.8005",
      "products-ui-components-shared-msw-handlers": "static-1.10405",
      "data-agent-kit": "static-1.232",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10106",
      "fsm": "static-1.3755",
      "policy-lib": "static-1.6801",
      "react-tinymce": "static-1.55312",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54438",
      "tinymce-plugins": "static-1.57552",
      "tinymce-themes": "static-1.56408",
      "content-media-composition-data-lib": "static-1.12397",
      "content-media-compositions": "static-2.16404",
      "idb-keyval": "static-1.44",
      "media-bridge-lib": "static-1.18967",
      "seat-types-lib": "static-1.66",
      "ui-addon-opt": "static-4.8388",
      "commerce-tours-lib": "static-1.6147",
      "growth-onboarding-reliability": "static-1.5106",
      "sales-checkout-service-client": "static-1.3666",
      "calling-cross-tab-library": "static-1.19311",
      "calling-lifecycle-usage-tracker": "static-1.8770",
      "purchase-motions-api": "static-1.5966",
      "reactive-lib": "static-1.747",
      "card-payment-highlight-lib": "static-1.37248",
      "card-subscription-highlight-lib": "static-1.39615",
      "commerce-contract-lib": "static-1.12176",
      "invoices-highlight-card-lib": "static-1.54806",
      "orders-highlight-card-lib": "static-1.21539",
      "products-highlight-card-lib": "static-1.17940",
      "quotes-highlight-card-lib": "static-1.72133",
      "usage-based-billing-components-lib": "static-1.9011",
      "utility-belt": "static-1.2558",
      "payments-enrollment-embed-lib": "static-1.22971",
      "stripe-embedded-components": "static-1.7547",
      "growth-onboarding-empty-states": "static-1.5777",
      "InboxConnectUtils": "static-4.14883",
      "payments-post-enroll-local-storage-lib": "static-1.5133",
      "qrcode-generator": "static-1.69",
      "trials-service-types": "static-1.3928",
      "reporting-client-types": "static-1.2500",
      "react-flip-move": "static-1.70",
      "FireAlarmUi": "static-1.4530",
      "sales-templates-service-types-lib": "static-1.4188",
      "ui-asset-management-lib": "static-1.11068",
      "association-settings-lib": "static-1.10354",
      "collaboration-sidebar": "static-1.57902",
      "conditional-property-settings-modal": "static-1.12501",
      "data-model-commons-lib": "static-1.12685",
      "ExportDialog": "static-6.10408",
      "final-form": "static-1.70",
      "html-to-image": "static-1.54",
      "nudge-client-utils": "static-1.2639",
      "object-definition-builder-lib": "static-1.7127",
      "property-management-iframe": "static-1.13241",
      "property-usages-lib": "static-1.5464",
      "reactflow": "static-1.64",
      "simple-data-table": "static-1.2850",
      "used-in-list-lib": "static-1.6982",
      "visual-association": "static-1.5908",
      "highcharts": "static-8.104",
      "reporting-visualizations": "static-1.59737",
      "ui-extensibility-client-types": "static-1.3948",
      "google-sheets-integration-lib": "static-1.312",
      "microsoft-drive-integration-lib": "static-1.444",
      "slack-ui-library": "static-1.10416",
      "automation-platform-service-types": "static-1.2593",
      "ContentData": "static-1.68513",
      "email-portal-health-service-types": "static-1.1002",
      "marketing-email-service-types": "static-1.1920",
      "ai-rendering-library": "static-1.10257",
      "ai-settings-ui-library": "static-1.7921",
      "breeze-engine-lib": "static-1.729",
      "ui-brand-identity-lib": "static-1.15380",
      "messaging-shared-utils-lib": "static-1.658",
      "messaging-user-info-utils-lib": "static-1.828",
      "content-whatsapp-service-types": "static-1.401",
      "marketing-platform-lib": "static-1.6882",
      "short-messages-app-service-client": "static-1.3993",
      "ui-tool-access": "static-1.10171",
      "onboarding-data-sync-lib": "static-1.1994",
      "growth-onboarding-next-action-components": "static-1.2018",
      "user-context-client": "static-1.4636",
      "nest": "static-1.253",
      "calling-orchestration-schema": "static-1.35858",
      "sales-views-client-types": "static-1.4283",
      "trellis-story-utils": "static-1.4539",
      "storybook-react": "static-1.33",
      "hub-http-contrib": "static-1.3066",
      "interframe": "static-3.4784",
      "tinymce-data": "static-1.40523",
      "ui-addon-sales-email": "static-1.5235",
      "codemirror": "static-5.95",
      "layout-dnd-components": "static-1.12491",
      "layout-dnd-utils": "static-1.11466",
      "react-codemirror": "static-1.10650",
      "NamespacedHubStyle": "static-2.9076",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.40175",
      "accounting-integrations-ui-components": "static-1.7102",
      "invoices-ui-lib": "static-1.54822",
      "commerce-products-api": "static-1.2332",
      "invoices-iframe-lib": "static-1.56880",
      "quotes-modal-lib": "static-1.102811",
      "quotes-ui-lib": "static-1.80854",
      "platform-infra-nav-components": "static-1.7689",
      "reporting-ui-components": "static-2.64932",
      "subscription-experience-data-types": "static-1.14968",
      "marketplace-ui-apps-core": "static-1.18356",
      "stripe-connect-js": "static-1.69",
      "ui-addon-react-router-dom": "static-1.9566",
      "nested-table": "static-1.250",
      "chatspot-widget-iframe": "static-1.21403",
      "collaboration-sidebar-common": "static-1.2699",
      "crm-properties-common-lib": "static-1.5909",
      "nudge-custom-function-registry": "static-1.2396",
      "nudge-renderer-utils": "static-1.2715",
      "whisper-core-api": "static-1.6692",
      "property-management-common": "static-1.5529",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15164",
      "advanced-menus-lib": "static-1.12102",
      "ui-memberships-settings-lib": "static-1.34115",
      "breeze-onboarding-components": "static-1.75",
      "embedded-academy-lib": "static-1.14428",
      "highlight.js": "static-1.79",
      "reporting-action-components": "static-1.41376",
      "reporting-snowflake": "static-1.56279",
      "meetings-connect-utils-lib": "static-1.7629",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9791",
      "browser-eslint": "static-2.57",
      "commerce-tax-lib": "static-1.551",
      "price-books-api": "static-1.848",
      "price-books-components": "static-1.906",
      "property-description-translator": "static-1.3867",
      "ramp-editor": "static-1.205",
      "commerce-analytics-service-client": "static-1.3654",
      "totals-ui-components": "static-1.23670",
      "reporting-plugins": "static-1.10364",
      "reporting-reports": "static-1.67339",
      "edison-service-client-types": "static-1.413",
      "developer-experience-shared-components": "static-1.10534",
      "marketplace-ui-client-types": "static-1.17230",
      "marketplace-ui-common": "static-1.19823",
      "ui-addon-integrations-directory-panel": "static-2.8023",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.196",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15163",
      "simple-menus-lib": "static-1.16680",
      "academy-common-lib": "static-1.13888",
      "dashboard-lib": "static-1.81631",
      "share-with-third-party-component-lib": "static-1.8726",
      "line-items-api": "static-1.732",
      "commerce-totals-service-types": "static-1.3837",
      "campaign-roi-lib": "static-1.9189",
      "apps-service-types": "static-1.3904",
      "oauth-service-types": "static-1.4274",
      "academy-service-client": "static-1.3706",
      "croppie": "static-2.10",
      "trellis-ecosystem": "static-1.7183",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.29407",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9691",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4741",
      "atom": "/atom/static-1.5097",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8910",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16003",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12944",
      "conversations-message-history": "/conversations-message-history/static-1.12766",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10528",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.22770",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5615",
      "hs-test-utils": "/hs-test-utils/static-1.8038",
      "hubspot-dlb": "/hubspot-dlb/static-2.1854",
      "HubStyleTokens": "/HubStyleTokens/static-2.11496",
      "I18n": "/I18n/static-7.1631",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.3045",
      "jasmine-runner": "/jasmine-runner/static-1.6488",
      "quartz": "/quartz/static-1.7062",
      "react-dlb": "/react-dlb/static-1.79",
      "react-select-plus": "/react-select-plus/static-1.105",
      "react-transition-group": "/react-transition-group/static-2.65",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4500",
      "StyleGuideUI": "/StyleGuideUI/static-3.487",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4561",
      "usage-tracker": "/usage-tracker/static-1.7372",
      "usage-tracker-core": "/usage-tracker-core/static-1.7222",
      "usage-tracker-public": "/usage-tracker-public/static-1.7183",
      "viral-links-lib": "/viral-links-lib/static-1.7090",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6161",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4838",
      "conversations-prop-types": "/conversations-prop-types/static-1.7476",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.21507",
      "cssUtils": "/cssUtils/static-1.798",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.341",
      "foundations-components": "/foundations-components/static-1.7983",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6246",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
      "immutable": "/immutable/static-2.79",
      "metrics-js": "/metrics-js/static-1.9637",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.186",
      "react-aria": "/react-aria/static-1.66",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.71",
      "react-rhumb": "/react-rhumb/static-1.16695",
      "react-utils": "/react-utils/static-2.5362",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8167",
      "signup-constants": "/signup-constants/static-1.18888",
      "styled-components": "/styled-components/static-2.89",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5786",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5972",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3417",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.82",
      "quartz-config": "/quartz-config/static-1.840",
      "quartz-core": "/quartz-core/static-1.6281",
      "foundations-assets": "/foundations-assets/static-1.4892",
      "foundations-theming": "/foundations-theming/static-1.4444",
      "UIComponents": "/UIComponents/static-3.8442",
      "conversations-async-data": "/conversations-async-data/static-2.7687",
      "customer-data-email": "/customer-data-email/static-1.18074",
      "cv-backend-services": "/cv-backend-services/static-1.1553",
      "immutable-less": "/immutable-less/static-1.4677",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7272",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33266",
      "customer-data-objects": "/customer-data-objects/static-1.7697",
      "icons": "/icons/static-2.650",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4676",
      "ui-images": "/ui-images/static-2.1160",
      "HeadJS": "/HeadJS/static-2.764",
      "framer-motion": "/framer-motion/static-1.72",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3149",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.152",
      "i18n-data": "/i18n-data/static-1.221",
      "moment-timezone": "/moment-timezone/static-5.83",
      "jasmine": "/jasmine/static-4.4351",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8077",
      "HubStyle": "/HubStyle/static-2.11803",
      "quartz-i18n": "/quartz-i18n/static-1.737",
      "sassPrefix": "/sassPrefix/static-1.156",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4252",
      "floating-ui": "/floating-ui/static-1.56",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2160",
      "hs-story-utils": "/hs-story-utils/static-1.9448",
      "react-create-root-preference": "/react-create-root-preference/static-1.29",
      "react-virtualized": "/react-virtualized/static-2.99",
      "tanstack-table": "/tanstack-table/static-1.55",
      "trellis-assets": "/trellis-assets/static-1.2023",
      "ui-fonts": "/ui-fonts/static-1.758",
      "hs-locale-management": "/hs-locale-management/static-1.98",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.727",
      "quick-fetch": "/quick-fetch/static-1.3934",
      "web-vitals": "/web-vitals/static-1.6",
      "quartz-routing": "/quartz-routing/static-1.492",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5789",
      "bender-build-tools": "/bender-build-tools/static-1.3215",
      "dispatcher": "/dispatcher/static-1.137",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.838",
      "hubspotter-http": "/hubspotter-http/static-1.4669",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
      "module-federation": "/module-federation/static-1.23",
      "quartz-auth": "/quartz-auth/static-1.737",
      "quartz-test": "/quartz-test/static-1.737",
      "quartz-tracking": "/quartz-tracking/static-1.441",
      "usage-tracker-container": "/usage-tracker-container/static-1.7362",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2927",
      "foundations-theming-base": "/foundations-theming-base/static-1.3429",
      "stylex": "/stylex/static-1.33",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4676",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9850",
      "FileManagerCore": "/FileManagerCore/static-1.39188",
      "FileManagerLib": "/FileManagerLib/static-1.39329",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4903",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.525",
      "timezone-utils": "/timezone-utils/static-2.5269",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10374",
      "ts-schema": "/ts-schema/static-1.4098",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9035",
      "avatar-components": "/avatar-components/static-1.2522",
      "content-assistance-lib": "/content-assistance-lib/static-1.7788",
      "crm-component-utils": "/crm-component-utils/static-1.39144",
      "crm-display-components": "/crm-display-components/static-1.24894",
      "crm-fe-perf": "/crm-fe-perf/static-1.22928",
      "crm-links": "/crm-links/static-1.6319",
      "crm-message-bus": "/crm-message-bus/static-1.43040",
      "crm-search-service-types": "/crm-search-service-types/static-1.1178",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5367",
      "customer-data-communicator": "/customer-data-communicator/static-1.45614",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39889",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13053",
      "customer-data-properties": "/customer-data-properties/static-1.51649",
      "customer-data-rte": "/customer-data-rte/static-1.33062",
      "draft-plugins": "/draft-plugins/static-2.21716",
      "file-manager-components": "/file-manager-components/static-1.23689",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6909",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7951",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18299",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10727",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.648",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8119",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18032",
      "universal-associations-select": "/universal-associations-select/static-1.11062",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.974",
      "wootric-nps": "/wootric-nps/static-1.6998",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3864",
      "property-translator": "/property-translator/static-1.5423",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.86",
      "chirp-fetch": "/chirp-fetch/static-1.1912",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10023",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10021",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5058",
      "react-dnd-compat": "/react-dnd-compat/static-1.4639",
      "audio-components": "/audio-components/static-1.5951",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29339",
      "FileManagerImages": "/FileManagerImages/static-1.36840",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1008",
      "immerable": "/immerable/static-1.4178",
      "ui-universal-auth": "/ui-universal-auth/static-1.9007",
      "video-components": "/video-components/static-1.13357",
      "video-data-lib": "/video-data-lib/static-1.35012",
      "video-embed": "/video-embed/static-1.35846",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.362",
      "chatspot-core": "/chatspot-core/static-1.21412",
      "ContentUtils": "/ContentUtils/static-1.68438",
      "copilot-toolkit": "/copilot-toolkit/static-1.11197",
      "superstore": "/superstore/static-1.4785",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8727",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28630",
      "card-properties-lib": "/card-properties-lib/static-1.44261",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37192",
      "crm-actions": "/crm-actions/static-1.6351",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43662",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9350",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8115",
      "customer-data-tracking": "/customer-data-tracking/static-1.6914",
      "hs-resources": "/hs-resources/static-1.178",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3604",
      "pulse": "/pulse/static-1.601",
      "framework-data-table": "/framework-data-table/static-2.11969",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9336",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.947",
      "calling-error-reporting": "/calling-error-reporting/static-1.31333",
      "calling-internal-common": "/calling-internal-common/static-1.31326",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6565",
      "crm_data": "/crm_data/static-4.92040",
      "customer-data-content": "/customer-data-content/static-1.27331",
      "draft-content-plugins": "/draft-content-plugins/static-1.28335",
      "draft-convert": "/draft-convert/static-2.73",
      "draft-extend": "/draft-extend/static-3.75",
      "draft-js": "/draft-js/static-5.78",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24135",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24425",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18291",
      "integration-settings-components": "/integration-settings-components/static-1.15540",
      "integrations-lib": "/integrations-lib/static-1.16235",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5626",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7806",
      "nav-meta": "/nav-meta/static-1.29747",
      "onboarding-scopes": "/onboarding-scopes/static-1.6485",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6267",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.11683",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.38223",
      "react-colorpicker": "/react-colorpicker/static-2.10232",
      "reference-resolvers": "/reference-resolvers/static-1.8195",
      "rich-text-lib": "/rich-text-lib/static-1.19874",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3868",
      "sequences-lib": "/sequences-lib/static-1.8083",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11173",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9084",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9079",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10194",
      "user-context": "/user-context/static-1.5129",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5775",
      "events-data-lib": "/events-data-lib/static-1.248",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22324",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13189",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4743",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4023",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6814",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1004",
      "onboarding-tours": "/onboarding-tours/static-1.16658",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13754",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21589",
      "calling-global-api": "/calling-global-api/static-1.64597",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65979",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58273",
      "commerce-products-lib": "/commerce-products-lib/static-1.9657",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3815",
      "external-options-client-types": "/external-options-client-types/static-1.4177",
      "google-libphonenumber": "/google-libphonenumber/static-1.38",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4241",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.656",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3709",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48826",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3983",
      "property-value-citations": "/property-value-citations/static-1.2263",
      "smart-property-lib": "/smart-property-lib/static-1.7210",
      "tiered-pricing": "/tiered-pricing/static-1.1271",
      "zustand": "/zustand/static-1.74",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11014",
      "video-components-external": "/video-components-external/static-1.11354",
      "batch-promise": "/batch-promise/static-1.1566",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4157",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.28",
      "persist-promise": "/persist-promise/static-1.3723",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25450",
      "knowledge-content-types": "/knowledge-content-types/static-1.8496",
      "payment-link-components": "/payment-link-components/static-1.23610",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9912",
      "call-summary": "/call-summary/static-1.39287",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10169",
      "laboratory-lib": "/laboratory-lib/static-3.7180",
      "merchandise-lib": "/merchandise-lib/static-1.264",
      "purchase-motions-components": "/purchase-motions-components/static-1.5963",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9627",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.803",
      "content-icons-ui": "/content-icons-ui/static-1.2233",
      "social-insights-client-types": "/social-insights-client-types/static-1.22183",
      "outpost": "/outpost/static-1.4203",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4836",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5567",
      "magpie-types": "/magpie-types/static-1.5027",
      "simple-logging-lib": "/simple-logging-lib/static-1.3075",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6604",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46087",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16328",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4281",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.19156",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18607",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10443",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.104",
      "directed-graph": "/directed-graph/static-1.959",
      "event-emitter": "/event-emitter/static-1.972",
      "fast-json-patch": "/fast-json-patch/static-1.63",
      "customer-data-associations": "/customer-data-associations/static-1.7350",
      "reporting-data": "/reporting-data/static-1.67661",
      "tanstack-virtual": "/tanstack-virtual/static-1.30",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4787",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
      "self-service-api": "/self-service-api/static-1.10271",
      "crm_universal": "/crm_universal/static-1.22048",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9286",
      "content-embed-lib": "/content-embed-lib/static-1.7363",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12424",
      "remote-ui": "/remote-ui/static-1.65",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5633",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17082",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3037",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13650",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10390",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.521",
      "messaging-types-lib": "/messaging-types-lib/static-1.46084",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8247",
      "copilot-plugins": "/copilot-plugins/static-1.11170",
      "data-token-picker": "/data-token-picker/static-1.16448",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7940",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5466",
      "navigation-messaging": "/navigation-messaging/static-1.7437",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18520",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17638",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.724",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1209",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8934",
      "growth-data-modal": "/growth-data-modal/static-1.5465",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3091",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1990",
      "navigation-components": "/navigation-components/static-1.18110",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4872",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7575",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11061",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.1081",
      "commerce-permissions": "/commerce-permissions/static-1.794",
      "products-iframe-lib": "/products-iframe-lib/static-1.8005",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10405",
      "data-agent-kit": "/data-agent-kit/static-1.232",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10106",
      "fsm": "/fsm/static-1.3755",
      "policy-lib": "/policy-lib/static-1.6801",
      "react-tinymce": "/react-tinymce/static-1.55312",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54438",
      "tinymce-plugins": "/tinymce-plugins/static-1.57552",
      "tinymce-themes": "/tinymce-themes/static-1.56408",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12397",
      "content-media-compositions": "/content-media-compositions/static-2.16404",
      "idb-keyval": "/idb-keyval/static-1.44",
      "media-bridge-lib": "/media-bridge-lib/static-1.18967",
      "seat-types-lib": "/seat-types-lib/static-1.66",
      "ui-addon-opt": "/ui-addon-opt/static-4.8388",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6147",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5106",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3666",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19311",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8770",
      "purchase-motions-api": "/purchase-motions-api/static-1.5966",
      "reactive-lib": "/reactive-lib/static-1.747",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37248",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39615",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.12176",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54806",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21539",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17940",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72133",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9011",
      "utility-belt": "/utility-belt/static-1.2558",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22971",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7547",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5777",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14883",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5133",
      "qrcode-generator": "/qrcode-generator/static-1.69",
      "trials-service-types": "/trials-service-types/static-1.3928",
      "reporting-client-types": "/reporting-client-types/static-1.2500",
      "react-flip-move": "/react-flip-move/static-1.70",
      "FireAlarmUi": "/FireAlarmUi/static-1.4530",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4188",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11068",
      "association-settings-lib": "/association-settings-lib/static-1.10354",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57902",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12501",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12685",
      "ExportDialog": "/ExportDialog/static-6.10408",
      "final-form": "/final-form/static-1.70",
      "html-to-image": "/html-to-image/static-1.54",
      "nudge-client-utils": "/nudge-client-utils/static-1.2639",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7127",
      "property-management-iframe": "/property-management-iframe/static-1.13241",
      "property-usages-lib": "/property-usages-lib/static-1.5464",
      "reactflow": "/reactflow/static-1.64",
      "simple-data-table": "/simple-data-table/static-1.2850",
      "used-in-list-lib": "/used-in-list-lib/static-1.6982",
      "visual-association": "/visual-association/static-1.5908",
      "highcharts": "/highcharts/static-8.104",
      "reporting-visualizations": "/reporting-visualizations/static-1.59737",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3948",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.312",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.444",
      "slack-ui-library": "/slack-ui-library/static-1.10416",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2593",
      "ContentData": "/ContentData/static-1.68513",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1002",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1920",
      "ai-rendering-library": "/ai-rendering-library/static-1.10257",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7921",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.729",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15380",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.658",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.828",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.401",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6882",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3993",
      "ui-tool-access": "/ui-tool-access/static-1.10171",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1994",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2018",
      "user-context-client": "/user-context-client/static-1.4636",
      "nest": "/nest/static-1.253",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35858",
      "sales-views-client-types": "/sales-views-client-types/static-1.4283",
      "trellis-story-utils": "/trellis-story-utils/static-1.4539",
      "storybook-react": "/storybook-react/static-1.33",
      "hub-http-contrib": "/hub-http-contrib/static-1.3066",
      "interframe": "/interframe/static-3.4784",
      "tinymce-data": "/tinymce-data/static-1.40523",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5235",
      "codemirror": "/codemirror/static-5.95",
      "layout-dnd-components": "/layout-dnd-components/static-1.12491",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11466",
      "react-codemirror": "/react-codemirror/static-1.10650",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9076",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.40175",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7102",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54822",
      "commerce-products-api": "/commerce-products-api/static-1.2332",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56880",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102811",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80854",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7689",
      "reporting-ui-components": "/reporting-ui-components/static-2.64932",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14968",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18356",
      "stripe-connect-js": "/stripe-connect-js/static-1.69",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9566",
      "nested-table": "/nested-table/static-1.250",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21403",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2699",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5909",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2396",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2715",
      "whisper-core-api": "/whisper-core-api/static-1.6692",
      "property-management-common": "/property-management-common/static-1.5529",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15164",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12102",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34115",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.75",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.14428",
      "highlight.js": "/highlight.js/static-1.79",
      "reporting-action-components": "/reporting-action-components/static-1.41376",
      "reporting-snowflake": "/reporting-snowflake/static-1.56279",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7629",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9791",
      "browser-eslint": "/browser-eslint/static-2.57",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.551",
      "price-books-api": "/price-books-api/static-1.848",
      "price-books-components": "/price-books-components/static-1.906",
      "property-description-translator": "/property-description-translator/static-1.3867",
      "ramp-editor": "/ramp-editor/static-1.205",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3654",
      "totals-ui-components": "/totals-ui-components/static-1.23670",
      "reporting-plugins": "/reporting-plugins/static-1.10364",
      "reporting-reports": "/reporting-reports/static-1.67339",
      "edison-service-client-types": "/edison-service-client-types/static-1.413",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10534",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17230",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19823",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8023",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.196",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15163",
      "simple-menus-lib": "/simple-menus-lib/static-1.16680",
      "academy-common-lib": "/academy-common-lib/static-1.13888",
      "dashboard-lib": "/dashboard-lib/static-1.81631",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8726",
      "line-items-api": "/line-items-api/static-1.732",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3837",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.9189",
      "apps-service-types": "/apps-service-types/static-1.3904",
      "oauth-service-types": "/oauth-service-types/static-1.4274",
      "academy-service-client": "/academy-service-client/static-1.3706",
      "croppie": "/croppie/static-2.10",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7183",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.29407",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};